import React, { useContext, useMemo, useState } from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';
import ContentUsage from 'components/ContentUsage';
import Row from 'components/Common/Row';
import DashboardContext from 'contexts/DashboardContext';
import EntityDefinitionsContext from 'contexts/EntityDefinitionsContext';

const CompactAlert = styled.div`
  background-color: var(--color-badge-info-bg);
  border: 1px solid var(--color-badge-info-border);
  border-radius: 8px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const EntityAppUsageAlert = () => {
  const { dashboard } = useContext(DashboardContext);
  const { entityDetailsApps } = useContext(EntityDefinitionsContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const entityApps = useMemo(() => {
    if (!dashboard) {
      return [];
    }
    return entityDetailsApps.filter((app) =>
      app.tabs.some((t) => t.type === 'dashboard' && t.typeId === dashboard.id),
    );
  }, [dashboard, entityDetailsApps]);

  if (entityApps.length === 0) {
    return null;
  }

  const count = entityApps.length;
  const label = `This dashboard is used on ${count} entity app${count !== 1 ? 's' : ''}.`;

  return (
    <>
      <CompactAlert onClick={() => setIsOpen(true)}>
        <Row centerAlign style={{ gap: 4 }}>
          <Typography.Body type="Body 12">{label}</Typography.Body>
          <Icon icon="open-link" width={12} height={12} />
        </Row>
      </CompactAlert>
      <ContentUsage
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        type="dashboard"
      />
    </>
  );
};

export default EntityAppUsageAlert;
